/**
 * Centralised Clerk configuration for the frontend.
 *
 * The publishable key comes from VITE_CLERK_PUBLISHABLE_KEY in .env.local.
 * Vite exposes any env var prefixed with VITE_ to the browser at build time.
 */

export const CLERK_PUBLISHABLE_KEY: string = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ?? '';

/**
 * Throws a helpful error if the publishable key is missing. Called at app
 * startup so the developer sees the problem immediately, not at sign-in time.
 */
export function assertClerkConfigured(): void {
  if (!CLERK_PUBLISHABLE_KEY) {
    throw new Error(
      [
        'Missing VITE_CLERK_PUBLISHABLE_KEY.',
        '',
        'Add it to .env.local:',
        '  VITE_CLERK_PUBLISHABLE_KEY=pk_test_...',
        '',
        'Get your key from https://dashboard.clerk.com (Configure → API keys).',
      ].join('\n'),
    );
  }
}
